/** BE-2: parse `unreadCount` from list/detail API payloads. */
export function parseUnreadCount(raw: Record<string, unknown>): number {
  const v = raw.unreadCount ?? raw.unread_count;
  if (typeof v === "number" && Number.isFinite(v)) return Math.max(0, Math.floor(v));
  if (typeof v === "string" && /^\d+$/.test(v.trim())) return Math.max(0, parseInt(v.trim(), 10));
  return 0;
}

/** Display cap per API-SPEC (clients may cap at 99). Returns empty when count is 0. */
export function formatUnreadBadgeLabel(count: number): string {
  const n = Math.max(0, Math.floor(count));
  if (n <= 0) return "";
  if (n > 99) return "99+";
  return String(n);
}
